import { postData } from '../utils/ajax-utils';

/* eslint-disable @typescript-eslint/no-explicit-any */
declare const script_var: any;

export default function initFavorites(): void {
    document.addEventListener('DOMContentLoaded', () => {
        new Favorites();
    });
}

class Favorites {
    $buttons: NodeListOf<HTMLButtonElement>;

    constructor() {
        this.$buttons = document.querySelectorAll('.btn-favorite');
        this.init();
    }

    init(): void {
        // Gère l'état des boutons `btn-favorite`
        postData(script_var.ajax_url, {action: 'ajax_get_favorites'}).then(response => {
            if (response.success) {
                this.$buttons.forEach(($btn) => {
                    $btn.classList.add('visible');
                    const postId = Number($btn.getAttribute('data-post'));
                    if (response.data.includes(postId)) {
                        $btn.classList.add('btn-favorite--active');
                    }
                });
            }
        });
        // Gestion du click sur les boutons favoris, requête ajax permettant de mettre à jour en BDD
        this.$buttons.forEach(($btn) => {
            $btn.addEventListener('click', (evt) => {
                evt.preventDefault();

                const postId = $btn.getAttribute('data-post') ?? '';
                const mode = (!$btn.classList.contains('btn-favorite--active') ? 'add' : 'remove');
                
                postData(script_var.ajax_url, {action: 'ajax_update_favorites', id: postId, mode: mode}).then(response => {
                    if (response.success) {
                        $btn.classList.toggle('btn-favorite--active');
                    }
                });
            });
        });
    }
}


